import React from 'react';
import { formatDate } from '../../../../helper/formatDate';
import { getStatusBadge } from '../EnquiryList/enquiryUtils';

export const CallLogRemarkCell = ({ row }) => {
    const status = getStatusBadge(row.status);
    const hasNextDate = Boolean(row.nextDate);

    return (
        <div className="py-1" style={{ maxWidth: '380px' }}>
            {/* Conversation Remark Content */}
            <div
                className="p-2 bg-light-subtle rounded border border-light-subtle fs-12 text-body lh-sm mb-1.5"
                style={{ whiteSpace: 'pre-wrap', maxHeight: '70px', overflowY: 'auto' }}
            >
                {row.remark ? (
                    <span>{row.remark}</span>
                ) : (
                    <span className="text-muted fst-italic">No conversation remark recorded.</span>
                )}
            </div>

            {/* Bottom Meta: Outcome Status & Next Scheduled Date */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-1.5 fs-11">
                {/* Status Badge */}
                <span className={`badge bg-soft-${status.color} text-${status.color} px-2 py-0.5 text-capitalize fw-semibold`}>
                    {row.status === 'deleted' ? 'Not Interested' : status.label}
                </span>

                {/* Next Call Date Badge */}
                {hasNextDate ? (
                    <span className="text-primary fw-medium d-inline-flex align-items-center gap-1 bg-soft-primary px-2 py-0.5 rounded">
                        <i className="ri-time-line" />
                        <span>Next Call:</span>
                        <strong>{formatDate(row.nextDate)}</strong>
                    </span>
                ) : (
                    <span className="text-muted fst-italic">No next call set</span>
                )}
            </div>
        </div>
    );
};

export default CallLogRemarkCell;
